import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import { Fragment } from 'react';
import { UPGRADE_PAGE } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import { ASSIGN_SEAT, PRICING_PAGE_REDIRECT, REQUEST_SEAT } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import UIPurchaseMotionButton from 'ui-addon-upgrades/button/UIPurchaseMotionButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MarketingProPurchaseMotions = ({
  upgradeData,
  purchaseMotions,
  className,
  handlePurchaseMotionButtonClick
}) => {
  const hasSeatPM = purchaseMotions.includes(REQUEST_SEAT) || purchaseMotions.includes(ASSIGN_SEAT);
  const primaryCTAStyle = {
    width: '100%',
    height: `${!hasSeatPM && '60px'}`,
    borderRadius: '3px'
  };
  return /*#__PURE__*/_jsxs(UIButtonGroup, {
    className: className || 'm-y-8',
    orientation: "vertical",
    style: {
      display: 'flex',
      width: '80%',
      maxWidth: '260px'
    },
    children: [/*#__PURE__*/_jsx(UIPurchaseMotionButton, {
      className: "display-block m-x-auto m-bottom-6",
      use: "primary",
      level: 1,
      purchaseMotions: purchaseMotions,
      upgradeData: upgradeData,
      location: UPGRADE_PAGE,
      style: primaryCTAStyle,
      onClick: handlePurchaseMotionButtonClick
    }), /*#__PURE__*/_jsx("div", {
      className: "display-flex m-right-auto",
      children: purchaseMotions.slice(1).map((purchaseMotion, i) => {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(UIPurchaseMotionButton, {
            className: "display-block m-x-auto m-bottom-4",
            use: "link",
            level: i + 2,
            purchaseMotions: purchaseMotions,
            upgradeData: upgradeData,
            location: UPGRADE_PAGE,
            onClick: handlePurchaseMotionButtonClick,
            children: purchaseMotion === PRICING_PAGE_REDIRECT && /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.upgradeButton.viewPricing"
            })
          }), purchaseMotions.length === 3 && i === 0 && /*#__PURE__*/_jsx("span", {
            style: {
              color: 'darkgray'
            },
            className: "m-x-2",
            children: "|"
          })]
        }, i);
      })
    })]
  });
};
export default MarketingProPurchaseMotions;